module.exports = __webpack_public_path__ + "img/carteirinhaGatoFrente_1.4af1e535.jpeg";